import Modal from 'react-bootstrap/Modal';

import { ModalButton } from '../../styles/StyledComponents';

const DeleteConfirmationModal = ({ text, show, closeHandler, actionHandler }) => {
    // ----- Actions
    const handleClose = () => {
        closeHandler();
    };

    const handleAction = () => {
        actionHandler();
    };

    // ----- Render
    return (
        <Modal show={show} backdrop='static' centered onHide={handleClose}>
            <Modal.Header className='fw-bold' closeButton>
                Mensaje de confirmación
            </Modal.Header>
            <Modal.Body>{text}</Modal.Body>
            <Modal.Footer>
                <ModalButton className='cancel' onClick={handleClose}>
                    Cancelar
                </ModalButton>
                <ModalButton className='action' onClick={handleAction}>
                    Eliminar
                </ModalButton>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteConfirmationModal;
